import { Menu as AntMenu } from "antd";
import { ReactNode, useMemo } from "react";

import { useLoc, useRouter, useSchool } from "@app/shared/lib/hooks";

type Props = {
  mode: "vertical" | "horizontal";
  onSelect?: (eky: string) => void;
};

type MenuItem = { key: string; label: ReactNode; onClick: () => void };

export const Menu: React.FC<Props> = ({ mode, onSelect }) => {
  const { navigate } = useRouter();
  const loc = useLoc();
  const school = useSchool();

  const items = useMemo<MenuItem[]>(
    () =>
      [
        {
          key: "/",
          label: loc.word("Courses and materials"),
          onClick: () => navigate("/"),
        },
        school.isForumAvailable && {
          key: "/forum",
          label: loc.word("Forum"),
          onClick: () => navigate("/forum"),
        },
        {
          key: "/access",
          label: loc.word("Access and payments"),
          onClick: () => navigate("/access"),
        },
        school.partnership && {
          key: "/partnership",
          label: loc.word("Partnership"),
          onClick: () => navigate("/partnership"),
        },
        school.community?.enabled && {
          key: "/community",
          label: loc.word("Community"),
          onClick: () => navigate("/community"),
        },
      ].filter(Boolean) as MenuItem[],
    [loc, navigate, school.isForumAvailable, school.partnership, school.community?.enabled],
  );

  const selectedKey = useMemo(() => `/${window.location.pathname.split('/')[1] ?? ''}`, [window.location.pathname]);

  return (
    <AntMenu
      selectedKeys={[selectedKey]}
      mode={mode}
      items={items}
      onSelect={(e) => onSelect?.(e.key)}
      className="flex-1"
    />
  );
};
